import type { ButtonHTMLAttributes, DetailedHTMLProps, Ref } from "react";

import "../../styles/buttons/Button.css";
export { Button };

/**
 * <button/> with className={'Button'}
 * @param props
 * @returns
 */
const Button = ({
  ref,
  ...props
}: DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  ref?: Ref<HTMLButtonElement>;
}) => {
  return (
    <button
      {...props}
      ref={ref}
      className={"Button " + (props.className ?? "")}
    />
  );
};
